module.exports = __webpack_public_path__ + "static/media/promo.1b29c1ef.svg";